import axios from 'axios';
import type { Estrategia } from '@eleg360/types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const estrategiasApi = {
  generate: async (
    data: {
      bairro: string;
      tema: string;
    },
    token: string,
  ) => {
    const res = await axios.post<Estrategia>(`${API_URL}/oto/estrategias/gerar`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (token: string) => {
    const res = await axios.get<Estrategia[]>(`${API_URL}/oto/estrategias`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Estrategia>(`${API_URL}/oto/estrategias/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/oto/estrategias/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
